<template>
    <div id="app" :class="langCode">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "App",
        computed:{
            langCode(){
                return 'lang-code-'+((this.$store.state.config.generalSettings) ? this.$store.state.config.generalSettings.language_id : (localStorage.getItem('lang')) ? localStorage.getItem('lang') : process.env.KIPAKI_locale)
            }
        },
        created() {
            document.title = (this.$store.getters.getConfig("generalSettings")) ? this.$store.getters.getConfig(
                "generalSettings").title : "KiPaKi | Ein Kinderhilfswerk in Ihrer Region";
            serverBus.$on('titleChange', title => {
                document.title = title;
            });
        }
    };

</script>

<style lang="scss">
    :root {
        --primary-color: #183756;
        --primary-color-shade: #9db0c3;
        --white-color: #fff;
        --black-color: #000;
        --base-theme-color:#7f7f7d;
        --base-font:16px;
        --base-text-color:#626262;
        --verticle-line-color:#676750;
        --icon-verticle-line-color:#545454;
        --theme-btn-background:#f3f3f4;
        --cancel-btn-color:#575757;
        --radio-btn-color:#e9e9e9;
        --list-card-bg-color:#f5f5f5;
        --card-border-color:#dfe1e5;
        --inactive-status-color:#616161;
        --list-description-color:#808080;
        --active-status-color:#67c23a;
        --table-theme-light-color:#cececd;
        --reject-btn-color:#f00;
        --table-row-hover-color:#fbfbe9;
    }

    @import url("https://fonts.googleapis.com/css?family=Open+Sans:400,300,600,700&subset=all");
    @import url('https://cdnjs.cloudflare.com/ajax/libs/gridstack.js/0.2.6/gridstack.min.css');
    @import "./assets/sass/_common.scss";

    .is-danger {
        color: #ea5b5b;
    }
    input:read-only{
        color: #908c8c;
        border-color:#b0b0b0;
        background-color: #f5f5f5;
        &:focus{
            border-color:#b0b0b0;
        }
    }
    input:-moz-read-only {
        color: #908c8c;
        border-color:#b0b0b0;
        background-color: #f5f5f5;
        &:focus{
            border-color:#b0b0b0;
        }
    }
    #nprogress {
        .bar {
            z-index: 9999;
            height: 4px;
            background-color: var(--primary-color-lighter);
        }
    }
    @media only screen and (max-width: 1680px){
        :root {
            --base-font:14px;
        }
    }
    @media only screen and (max-width: 768px){
        :root {
            --base-font:12px;
        }
    }

</style>
<style>
    body,html{
        height: 100%;
    }
    #app {
        font-family: "Open Sans", sans-serif, Arial;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue